export default "/_next/static/images/2015-1x-eb9479c198401d6dc9b96fbe06a1d535.png";